/** Shown when saving or skipping a calling status fails. The view does not advance. */
export const CALLING_STATUS_SAVE_ERROR = 'Calling status could not be saved.';

/**
 * Saves calling status, then the Rocket form. Returns false when either step
 * fails so the caller can leave the contact in place.
 */
export async function persistCallingStatusChange(steps: {
  update: () => Promise<unknown>;
  saveRocketForm: () => Promise<unknown>;
  onError: () => void;
}): Promise<boolean> {
  try {
    await steps.update();
    await steps.saveRocketForm();
    return true;
  } catch {
    steps.onError();
    return false;
  }
}
